import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TenantsService } from '../../services/tenants.service';
import { SelectedTenantService } from '../../services/selected-tenant.service';
import { ToastrService } from '../../services/toastr.service';
import { TenantSummary } from '../../models/tenant.model';
import { LoaderComponent } from '../../common/loader/loader.component';

@Component({
  selector: 'app-tenant-dashboard',
  imports: [LoaderComponent],
  templateUrl: './tenant-dashboard.component.html',
  styleUrl: './tenant-dashboard.component.scss'
})
export class TenantDashboardComponent implements OnInit {
  isGridView = true;
  tenants: TenantSummary[] = [];
  loading = true;

  constructor(
    private router: Router,
    private tenantsService: TenantsService,
    private selectedTenantService: SelectedTenantService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.tenantsService.getTenants().subscribe({
      next: (tenants) => {
        this.tenants = tenants;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastrService.error('Unable to load tenants.');
      }
    });
  }

  setView(isGrid: boolean): void {
    this.isGridView = isGrid;
  }

  openTenant(tenant: TenantSummary): void {
    this.selectedTenantService.set(tenant);
    this.router.navigate(['/tenants', tenant.tenant_uid]);
  }
}
